<template>
  <v-sheet outlined class="pa-4" width="100%">
    <v-row class="d-flex align-center justify-space-between pb-2" no-gutters>
      <v-col cols="auto" class="d-flex align-center">
        <v-icon small color="secondary" class="mr-2">filter_list</v-icon>
        <span class="subtitle-2 font-weight-medium secondary--text">
          Filtros de búsqueda
        </span>
      </v-col>
      <v-col cols="auto">
        <v-btn
          class="text-capitalize"
          color="botonRefrescar"
          text
          small
          @click="$emit('limpiar')"
        >
          <v-icon left small>delete</v-icon>
          Limpiar Filtros
        </v-btn>
      </v-col>
    </v-row>

    <v-row align="start" dense>
      <v-col cols="12" sm="6" md="4" v-if="convenios.length > 0">
        <v-autocomplete
          :items="convenios"
          label="Convenio*"
          :value="value.convenio"
          item-value="empresaId"
          item-text="razon_social"
          return-object
          dense
          outlined
          clearable
          hide-details
          @change="cambiarConvenio"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          :items="empresas"
          label="Empresa"
          :value="value.empresa"
          item-value="nit"
          item-text="razon_social"
          return-object
          dense
          outlined
          clearable
          hide-details
          @change="cambiarEmpresa"
          @click:clear="limpiarEmpresa"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          :items="sucursales"
          label="Sucursal"
          :value="value.sucursal"
          item-value="IdSucursal"
          item-text="descripcion_sucursal"
          return-object
          dense
          outlined
          clearable
          hide-details
          @change="cambiarSucursal"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          :value="value.tipoContrato"
          :items="tiposContratos"
          label="Tipo Contrato"
          item-value="_id"
          item-text="DescTipoContrato"
          return-object
          outlined
          dense
          clearable
          hide-details
          @change="cambiarTipoContrato"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4" v-if="convenios.length > 0">
        <v-autocomplete
          :value="value.estadoEmpleado"
          label="Estado Empleado"
          :items="estadosEmpleado"
          outlined
          dense
          clearable
          hide-details
          @change="cambiarEstadoEmpleado"
        />
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-autocomplete
          :value="value.estadoCartera"
          label="Estado Cartera"
          :items="estadosCartera"
          outlined
          dense
          clearable
          hide-details
          @change="cambiarEstadoCartera"
        />
      </v-col>
    </v-row>
  </v-sheet>
</template>

<script>
export default {
  name: 'RegistrarFiltro',

  props: {
    value: {
      type: Object,
      required: true,
    },
    empresas: {
      type: Array,
      default: () => [],
    },
    convenios: {
      type: Array,
      default: () => [],
    },
    sucursales: {
      type: Array,
      default: () => [],
    },
    tiposContratos: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      estadosEmpleado: ['DISPONIBLE', 'NO DISPONIBLE'],
      estadosCartera: ['BLOQUEADO', 'DESBLOQUEADO'],
    };
  },

  methods: {
    actualizarFiltro(campo, valor) {
      this.$emit('input', { ...this.value, [campo]: valor });
    },

    cambiarConvenio(valor) {
      if (!valor) {
        this.$emit('limpiar');
        return;
      }
      this.actualizarFiltro('convenio', valor);
      this.$emit('convenio-change');
    },

    cambiarEmpresa(valor) {
      this.actualizarFiltro('empresa', valor);
      this.$emit('empresa-change');
    },

    limpiarEmpresa() {
      this.$emit('input', { ...this.value, empresa: null, sucursal: null });
      this.$emit('empresa-change');
      this.$emit('aplicar-filtros');
    },

    cambiarSucursal(valor) {
      this.actualizarFiltro('sucursal', valor);
      this.$emit('aplicar-filtros');
    },

    cambiarTipoContrato(valor) {
      this.actualizarFiltro('tipoContrato', valor);
      this.$emit('aplicar-filtros');
    },

    cambiarEstadoEmpleado(valor) {
      this.actualizarFiltro('estadoEmpleado', valor);
      this.$emit('aplicar-filtros');
    },

    cambiarEstadoCartera(valor) {
      this.actualizarFiltro('estadoCartera', valor);
      this.$emit('aplicar-filtros');
    },
  },
};
</script>
